// extracted by mini-css-extract-plugin
export default {"multiline-text":"duplicate-hierarchy-modal__multiline-text--JyfD8","multilineText":"duplicate-hierarchy-modal__multiline-text--JyfD8"};